import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

const createDisplay = (display = '') => display
// snake_case → space
  .replace(/_/g, ' ')
// camelCase → space before capital when previous is lowercase
  .replace(/([a-z])([A-Z])/g, '$1 $2')
// normalize spacing
  .replace(/\s+/g, ' ')
  .trim();

const FilterRow = ({ filterOptions, schema, filter, updateFilter, deleteFilter, isFormattingTag, index }) => {
  const handleUpdate = (updated) => {
    updateFilter(filter.id, updated);
  };

  return (
    <div className='d-flex flex-column flex-sm-row mb-3'>
      <div className='row gx-2' style={{ maxWidth: '550px' }}>

        <div
          className='form-group col-12 col-sm-4 mb-3 mb-sm-0'
        >
          <label htmlFor='filterKey' className='form-label'>Column</label>
          <select
            id='filterKey'
            className='form-select'
            aria-label='Filter Key'
            name='filterKey'
            onChange={(e) => {
              const type = schema.find((d) => d.name === e.target.value);
              const updated = {
                ...filter,
                filterKey: e.target.value,
                type,
                operatorValue: (type.type === 'string' || type.type === 'boolean' || type.type === 'tags') ? 'is' : '',
                filterValue: '',
              };
              handleUpdate(updated);
            }}
            value={filter.filterKey}>
            <option value=''>Select</option>
            {filterOptions.map((d, i) => <option key={i} value={d.name}>{d.display}</option>)}
          </select>
        </div>

        {(filter.filterKey === '') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <input id='operatorValue' className='form-control' name='operatorValue' disabled value='' aria-label='Text Operator Value' />
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <input id='filterValue' className='form-control' name='filterValue' disabled value='' aria-label='Text Filter Value' />
            </div>
          </>
        }

        {/* STRING */}
        {(filter.type.type === 'string') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <select
                id='operatorValue'
                className='form-select'
                aria-label='Filter Operator Value'
                aria-labelledby='Filter Operator Value'
                name='operatorValue'
                onChange={(e) => {
                  const updated = { ...filter, operatorValue: e.target.value };
                  if (updated.operatorValue === 'is blank' || updated.operatorValue === 'is not blank') {
                    updated.filterValue = ' ';
                  } else {
                    if (updated.filterValue === ' ') {
                      updated.filterValue = '';
                    }
                  }
                  handleUpdate(updated);
                }}
                value={filter.operatorValue}
              >
                <option value='is'>Is</option>
                <option value='is not'>Is Not</option>
                {/* For HAF Applicants table */}
                {filter.filterKey !== 'status' && (
                  <>
                    <option value='is blank'>Is Blank</option>
                    <option value='is not blank'>Is Not Blank</option>
                  </>
                )}
              </select>
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <input
                id='filterValue'
                disabled={filter.operatorValue === 'is blank' || filter.operatorValue === 'is not blank'}
                className='form-control'
                type='text'
                name='filterValue'
                aria-label='String Filter Value'
                onChange={(e) => {
                  const updated = { ...filter, filterValue: e.target.value };
                  handleUpdate(updated);
                }}
                value={filter.filterValue}
              />
            </div>
          </>
        }

        {/* NUMBER */}
        {(filter.type.type === 'number') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <select
                id='operatorValue'
                className='form-select'
                name='operatorValue'
                aria-label='Filter Operator Value'
                onChange={(e) => {
                  const updated = { ...filter, operatorValue: e.target.value };
                  if (updated.operatorValue === 'is blank' || updated.operatorValue === 'is not blank') {
                    updated.filterValue = ' ';
                  } else {
                    if (updated.filterValue === ' ') {
                      updated.filterValue = '';
                    }
                  }
                  handleUpdate(updated);
                }}
                value={filter.operatorValue}
              >
                <option value=''>Select One</option>
                <option value='is equal to'>Is Equal To</option>
                <option value='is less than'>Is Less Than</option>
                <option value='is greater than'>Is Greater Than</option>
                {/* For HAF Applicants table */}
                {filter.filterKey !== 'days_in_status' && (
                  <>
                    <option value='is blank'>Is Blank</option>
                    <option value='is not blank'>Is Not Blank</option>
                  </>
                )}
              </select>
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <input
                id='filterValue'
                disabled={filter.operatorValue === 'is blank' || filter.operatorValue === 'is not blank'}
                className='form-control'
                type='number'
                name='filterValue'
                aria-label='Number Filter Value'
                onChange={(e) => {
                  const updated = { ...filter, filterValue: e.target.value };
                  handleUpdate(updated);
                }}
                value={filter.filterValue}
              />
            </div>
          </>
        }

        {/* BOOLEAN */}
        {(filter.type.type === 'boolean') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <select
                id='operatorValue'
                className='form-select'
                name='operatorValue'
                aria-label='Filter Operator Value'
                onChange={(e) => {
                  const updated = { ...filter, operatorValue: e.target.value };
                  if (updated.operatorValue === 'is blank' || updated.operatorValue === 'is not blank') {
                    updated.filterValue = ' ';
                  } else {
                    if (updated.filterValue === ' ') {
                      updated.filterValue = '';
                    }
                  }
                  handleUpdate(updated);
                }}
                value={filter.operatorValue}
              >
                <option value='is'>Is</option>
                <option value='is not'>Is Not</option>
              </select>
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <select
                id='filterValue'
                disabled={filter.operatorValue === 'is blank' || filter.operatorValue === 'is not blank'}
                className='form-select'
                name='filterValue'
                aria-label='Boolean Filter Value'
                onChange={(e) => {
                  const updated = { ...filter, filterValue: e.target.value };
                  handleUpdate(updated);
                }}
                value={filter.filterValue}
              >
                <option value=''>Select One</option>
                <option value='true'>True</option>
                <option value='false'>False</option>
              </select>
            </div>
          </>
        }

        {/* DATE */}
        {(filter.type.type === 'date') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <select
                id='operatorValue'
                className='form-select'
                name='operatorValue'
                aria-label='Filter Operator Value'
                onChange={(e) => {
                  const updated = { ...filter, operatorValue: e.target.value };
                  if (updated.operatorValue === 'is blank' || updated.operatorValue === 'is not blank') {
                    updated.filterValue = ' ';
                  } else {
                    if (updated.filterValue === ' ') {
                      updated.filterValue = '';
                    }
                  }
                  handleUpdate(updated);
                }}
                value={filter.operatorValue}
              >
                <option value=''>Select One</option>
                <option value='before'>Before</option>
                <option value='after'>After</option>
                <option value='on'>On</option>
                <option value='is blank'>Is Blank</option>
                <option value='is not blank'>Is Not Blank</option>
              </select>
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <input
                id='filterValue'
                disabled={filter.operatorValue === 'is blank' || filter.operatorValue === 'is not blank'}
                className='form-control'
                type='date'
                aria-label='Date Filter Value '
                name='filterValue'
                onChange={(e) => {
                  const updated = { ...filter, filterValue: e.target.value };
                  handleUpdate(updated);
                }}
                value={filter.filterValue}
              />
            </div>
          </>
        }

        {/* TAGS */}
        {(filter.type.type === 'tags') &&
          <>
            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='operatorValue' className='form-label'>Filter</label>
              <select
                id='operatorValue'
                className='form-select'
                name='operatorValue'
                aria-label='Filter Operator Value'
                onChange={(e) => {
                  const updated = { ...filter, operatorValue: e.target.value };
                  if (updated.operatorValue === 'is blank' || updated.operatorValue === 'is not blank') {
                    updated.filterValue = ' ';
                  } else {
                    if (updated.filterValue === ' ') {
                      updated.filterValue = '';
                    }
                  }
                  handleUpdate(updated);
                }}
                value={filter.operatorValue}
              >
                <option value='is'>Is</option>
                <option value='is not'>Is Not</option>
                <option value='is blank'>Is Blank</option>
                <option value='is not blank'>Is Not Blank</option>
              </select>
            </div>

            <div className='form-group col-12 col-sm-4 mb-3 mb-sm-0'>
              <label htmlFor='filterValue' className='form-label'>Value</label>
              <select
                id='filterValue'
                disabled={filter.operatorValue === 'is blank' || filter.operatorValue === 'is not blank'}
                className='form-select'
                type='text'
                aria-label='Tags Filter Value'
                name='filterValue'
                onChange={(e) => {
                  const updated = { ...filter, filterValue: e.target.value };
                  handleUpdate(updated);
                }}
                value={filter.filterValue}
              >
                <option value=''>Select One</option>
                {filter.type.options.map((d, i) => {
                  if (d && typeof d === 'object') {
                    return <option key={i} value={d.value}>{d.display}</option>;
                  }
                  return <option key={i} value={d}>{(d && isFormattingTag) ? createDisplay(d) : d}</option>;
                })}
              </select>
            </div>
          </>
        }
      </div>

      <div className='form-group ms-0 ms-sm-1'>
        <label htmlFor='none' className='d-none d-sm-block form-label invisible'>i</label>
        <Button
          ghost
          className='text-muted fw-normal'
          onClick={() => deleteFilter(filter)}
        >
          <span className='fas fa-times' />
        </Button>
      </div>
    </div>
  );
};

FilterRow.propTypes = {
  filterOptions: PropTypes.array,
  schema: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  filter: PropTypes.object,
  updateFilter: PropTypes.func,
  deleteFilter: PropTypes.func,
  isFormattingTag: PropTypes.bool,
  index: PropTypes.number,
};

export default FilterRow;
